import React, { FunctionComponent, useReducer, useEffect } from 'react';
import { useQuery } from 'react-query';

import { IReducerAction, IAppSettings, QueryKeys } from '@nxs/models';

type TAppSettingsContextActions = 'SET_APP_SETTINGS';

interface IAppSettingsContext {
    initialized: boolean;
    appSettings: IAppSettings;
}

const initialAppSettingsState: IAppSettings = {
    apiBaseUrl: ''
};
const initialState: IAppSettingsContext = {
    initialized: false,
    appSettings: {...initialAppSettingsState}
};
export const AppSettingsContext = React.createContext<IAppSettingsContext>(initialState);

const AppSettingsContextReducer = (state: IAppSettingsContext, action: IReducerAction<TAppSettingsContextActions>): IAppSettingsContext => {
    switch (action.type) {
        case 'SET_APP_SETTINGS':
            return { ...state, initialized: !!action.payload, appSettings: action.payload };
        default:
            return state;
    }
}

interface IAppSettingsContextProviderProps {
    children: any;
}
export const AppSettingsContextProvider: FunctionComponent<IAppSettingsContextProviderProps> = (props: IAppSettingsContextProviderProps) => {
    const [state, dispatch] = useReducer(AppSettingsContextReducer, {...initialState});

    const { data: appSettings = null } = useQuery<IAppSettings>([QueryKeys.AppSettings], async () => {
        const res = await fetch('/appsettings.json', {
            cache: 'no-store',
            method: 'GET'
        });
        return await res.json();
    });

    useEffect(() => {
        dispatch({
            type: 'SET_APP_SETTINGS',
            payload: appSettings
        });

        if (appSettings) {
            console.debug(`Environment: ${appSettings.environment}, Version: ${appSettings.buildVersion}`);
        }
    }, [appSettings]);

    if (!state.initialized) {
        return null;
    }

    return (
        <AppSettingsContext.Provider value={state}>
            {props.children}
        </AppSettingsContext.Provider>
    )
};